import React from "react";

interface Props {
  image: Picture;
  sizes?: string;
  onLoad?: (evt: React.SyntheticEvent) => void;
}

export default function Picture(props: Props) {
  const { image } = props;

  const sizes = props.sizes || "100vw";

  const handleLoaded = (evt: React.SyntheticEvent) => {
    if (props.onLoad) {
      props.onLoad(evt);
    }
  };

  return (
    <picture>
      {image.sources.map((source) => (
        <source
          key={source.type}
          type={source.type}
          srcSet={source.srcset}
          sizes={sizes}
        />
      ))}
      <img
        onLoad={handleLoaded}
        src={image.src}
        alt={image.alternative}
        srcSet={image.srcset ?? undefined}
        width={image.width}
        height={image.height}
        sizes={sizes}
      />
    </picture>
  );
}
